/** Icon size tokens — build-time constants (not CSS vars).
 *  Phosphor icons require `size: number`, so these remain as plain numbers. */
export const iconTokens = {
  size: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 32,
    '4xl': 48,
  },
} as const;

export type IconTokens = typeof iconTokens;
